import { render, staticRenderFns } from "./MurabbaEditor.vue?vue&type=template&id=5fa0d67c&"
import script from "./MurabbaEditor.vue?vue&type=script&lang=js&"
export * from "./MurabbaEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports